import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { UnblockPosValidationSchema } from "../pages/Show/schemas/unblockPos.schema"

interface UseUnblockPosModalProps {
  id?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useUnblockPos = ({ id, onSuccess, onError }: UseUnblockPosModalProps) => {
  const privateAxios = usePrivateAxios()
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['unblockPos', id],
    mutationFn: async (data: UnblockPosValidationSchema) => {
    await privateAxios.put(`/pos/machines/${id}/unblock`, {
        pos: {
         unblock_reason: data.description,
        }
      })
    },
    onSuccess: () => {
      if (id) {
        queryClient.invalidateQueries({queryKey: ["posMachineById", id]});
      }
      onSuccess?.();
    },
    onError,
  })
}